import React from 'react'
import style from './style.module.scss'

export default function CustomErrorComponent ({code, title}: {code: string, title: string}) {
  return <div className={style.container}>
    <h1 className={style.title}>{code}</h1>
    <h3 className={style.subtitle}>{title}</h3>
  </div>
}
